"use strict";
/* globals chrome, AsyncStorage */
Object.defineProperty(exports, "__esModule", { value: true });
exports.del = exports.set = exports.get = void 0;
/**
 * Original code by mondora <open@mondora.com>
 * was published under MIT license here:
 * https://github.com/mondora/asteroid
 */
const genericStorage = {};
function get(key) {
    return new Promise((resolve, reject) => {
        if (typeof chrome !== 'undefined' && chrome.storage) {
            chrome.storage.local.get(key, (data) => resolve(data[key]));
        }
        else if (typeof localStorage !== 'undefined') {
            resolve(localStorage[key]);
        }
        else if (typeof AsyncStorage !== 'undefined') {
            AsyncStorage.getItem(key, (error, data) => {
                if (error) {
                    reject(error);
                }
                else {
                    resolve(data);
                }
            });
        }
        else {
            resolve(genericStorage[key]);
        }
    });
}
exports.get = get;
function set(key, value) {
    return new Promise((resolve, reject) => {
        if (typeof chrome !== 'undefined' && chrome.storage) {
            const data = {
                [key]: value,
            };
            chrome.storage.local.set(data, resolve);
        }
        else if (typeof localStorage !== 'undefined') {
            localStorage[key] = value;
            resolve();
        }
        else if (typeof AsyncStorage !== 'undefined') {
            AsyncStorage.setItem(key, value, (error) => {
                if (error) {
                    reject(error);
                }
                else {
                    resolve();
                }
            });
        }
        else {
            genericStorage[key] = value;
            resolve();
        }
    });
}
exports.set = set;
function del(key) {
    return new Promise((resolve, reject) => {
        if (typeof chrome !== 'undefined' && chrome.storage) {
            chrome.storage.local.remove(key, resolve);
        }
        else if (typeof localStorage !== 'undefined') {
            delete localStorage[key];
            resolve();
        }
        else if (typeof AsyncStorage !== 'undefined') {
            AsyncStorage.removeItem(key, (error) => {
                if (error) {
                    reject(error);
                }
                else {
                    resolve();
                }
            });
        }
        else {
            delete genericStorage[key];
            resolve();
        }
    });
}
exports.del = del;
//# sourceMappingURL=multiStorage.js.map